import { ColumnDef } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { Lawyer } from '../../../types/lawyer';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';

// دالة لفتح مربع حوار الحذف (سيتم تمريرها كـ prop)
type OpenDeleteDialogFn = (lawyer: Lawyer) => void;

export const getLawyerColumns = (openDeleteDialog: OpenDeleteDialogFn): ColumnDef<Lawyer>[] => [
  {
    header: 'الاسم',
    accessorKey: 'name',
  },
  {
    header: 'رقم القيد بالنقابة',
    accessorKey: 'bar_number',
  },
  {
      header: 'البريد الإلكتروني',
      accessorFn: (row) => row.user?.email || 'N/A',
    },
  {
    header: 'الحالة',
    accessorKey: 'status',
  },
  {
    header: 'تاريخ الانتهاء',
    accessorFn: (row) => new Date(row.join_date).toLocaleDateString('ar-EG'),
  },
  {
    id: 'actions',
    header: 'إجراءات',
    cell: ({ row }) => {
      const lawyer = row.original;
      return (
        <div className={pageStyles.actionButtons}>
          <Link to={`/admin/lawyers/edit/${lawyer.id}`} className={`${pageStyles.actionButton} ${pageStyles.edit}`} title="تعديل">
            <Icon as={FaEdit} style={pageStyles.icon } />
            
          </Link>
          <button onClick={() => openDeleteDialog(lawyer)} className={`${pageStyles.actionButton} ${pageStyles.delete}`} title="حذف">
            <Icon as={FaTrashAlt} style={pageStyles.icon } />
            
          </button>
        </div>
      );
    },
  },
];
